export default __webpack_public_path__ + "images/link_arrow-23f36cc5bfa62613078a422ad5c21c19.svg";